// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom .el-form-item[data-v-39617e80] {\n  margin-bottom: 0;\n}\n.price[data-v-39617e80] {\n  font-size: 16px;\n  font-weight: bold;\n}\n.hint[data-v-39617e80] {\n  line-height: 15px;\n  margin-top: -10px;\n  color: #b2b2b2;\n}\n[data-v-39617e80] .avatar-uploader .el-upload {\n  border: none;\n}", ""]);
// Exports
module.exports = exports;
